import Layout from "@/admin/js/layout/index.vue";

const ticketsRoutes = {
    name: 'tickets',
    path: '/tickets',
    component: Layout,
    meta: { title: 'Техподдержка', noCache: false },
    redirect: '/tickets/list',
    children: [
        {
            path: 'list',
            component: () => import('@/admin/js/views/tickets/index.vue'),
            name: 'SupportTickets',
            meta: { title: 'Техподдержка' },
        },
        {
            path: ':id',
            component: () => import('@/admin/js/views/tickets/show.vue'),
            name: 'SupportTicketShow',
            hidden: true,
            meta: {
                title: 'Тикет',
                activeMenu: '/tickets',
                noCache: true,
            },
            props: true,
        },
    ],
};

export default ticketsRoutes;